module.exports = "/_next/static/images/analytics-monotone-9c1221e3836fb3d7dbf18a0284737ad1.svg";